import { RootState } from '@store/rootReducer'

const selectDeeplinkState = (state: RootState) => state.deeplink

export const selectDeeplinkFlows = (state: RootState) => selectDeeplinkState(state).flows
